import { Badge } from '@/components/ui/badge'

const STATUS_VARIANT_MAP: Record<string, 'default' | 'secondary' | 'outline' | 'destructive'> =
  {
    APPROVED: 'default',
    ACTIVE: 'default',
    PENDING: 'secondary',
    IN_REVIEW: 'secondary',
    REJECTED: 'destructive',
    DEACTIVATED: 'destructive',
    INACTIVE: 'destructive',
    EXPIRED: 'outline',
  }

function toLabel(value: string): string {
  return value
    .split(/[\s_-]+/)
    .map((part) => part.charAt(0).toUpperCase() + part.slice(1).toLowerCase())
    .join(' ')
}

export function RenewalStatusBadge({ status }: { status: string }) {
  const normalized = status?.toUpperCase?.() ?? 'PENDING'
  const variant = STATUS_VARIANT_MAP[normalized] ?? 'secondary'
  return <Badge variant={variant}>{toLabel(normalized)}</Badge>
}
